/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdAttachmentsDocumentRejectionReasons200,
  GetApiV1PersonIdAttachmentsDocumentRejectionReasons401,
  GetApiV1PersonIdAttachmentsDocumentRejectionReasons500,
  GetApiV1PersonIdAttachmentsDocumentRejectionReasonsPathParams,
  GetApiV1PersonIdAttachmentsDocumentRejectionReasonsQueryResponse,
} from "../../types/personDocumentsController/GetApiV1PersonIdAttachmentsDocumentRejectionReasons.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1PersonIdAttachmentsDocumentRejectionReasonsPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1PersonIdAttachmentsDocumentRejectionReasonsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdAttachmentsDocumentRejectionReasons200Schema =
  z.array(
    z.lazy(() => dropDownRepositoryResponseSchema),
  ) as unknown as ToZod<GetApiV1PersonIdAttachmentsDocumentRejectionReasons200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdAttachmentsDocumentRejectionReasons401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachmentsDocumentRejectionReasons401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdAttachmentsDocumentRejectionReasons500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachmentsDocumentRejectionReasons500>;

export const getApiV1PersonIdAttachmentsDocumentRejectionReasonsQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonIdAttachmentsDocumentRejectionReasons200Schema,
  ) as unknown as ToZod<GetApiV1PersonIdAttachmentsDocumentRejectionReasonsQueryResponse>;
